import React from 'react';
import styled from '@mui/system/styled';
import { useTranslation } from 'react-i18next';

import PageHeader from '../../../components/PageHeader';
import DashboardContent from './DashboardContent';

const Dashboard = (props) => {
	const { t } = useTranslation('dashboard');

	const StyledContainer = styled('div')(({ theme }) => ({
		display: 'flex',
		flexDirection: 'column',
		width: '100%'
	}));

	return (
		<StyledContainer>
			<PageHeader label={t('header')} />
			<DashboardContent />
		</StyledContainer>
	);
};

Dashboard.propTypes = {};

export default Dashboard;
